import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import T from '../../i18n/i18n';
import ResourceImage from '../../ResourceImage/ResourceImage';
import { Container, Title, CharactersList, ShortcutName, ShortcutItem, ShortcutImage, EmptyImage, Open } from './QuickSheet.styles';
import { charactersActions } from '../../../redux/actions';

export default () => {

    const dispatch = useDispatch();

    let [visible, setVisible] = useState(false);
    let [opened, setOpened] = useState(false);
    
    const shortcutsLastSize = useRef(0);
    const shortcuts = useSelector(state => state.charactersState.sheetShortcuts);

    useEffect(() => {
        setVisible(shortcuts.length > 0);

        if (shortcuts.length > shortcutsLastSize.current) {
            setOpened(true);
        }

        shortcutsLastSize.current = shortcuts.length;


    }, [shortcuts]);

    const handleItemClick = (charId) => {
        dispatch(charactersActions.setSheetFormOpened(true, charId));
    }

    return <Container className={`${opened ? 'opened' : ''} ${visible ? 'visible' : ''}`}>
        <CharactersList>
            <Title><T value={"charsheet.shortcutsheet"} /></Title>
            {shortcuts.map(s => <ShortcutItem key={s.id} onClick={()=>{handleItemClick(s.id)}}>
                <ShortcutImage>
                    {s.avatar && <ResourceImage resourceId={s.avatar} />}
                    {!s.avatar && <EmptyImage />}
                </ShortcutImage>
                <ShortcutName>{s.name}</ShortcutName>
            </ShortcutItem>)}
        </CharactersList>
        <Open onClick={()=>{setOpened(o => !o)}} />
    </Container>
}